import { OEText, mt } from '@openeducation/oe-it-components';
import { secondaryFontFamily } from '@openeducation/oe-it-themes';
import React from 'react';
import { View } from 'react-native';

interface PCFeedbackCardLessonTitleProps {
  lessonName: string | null;
}

export const PCFeedbackCardLessonTitle = ({
  lessonName,
}: PCFeedbackCardLessonTitleProps) => {
  return (
    <View style={[mt(16)]}>
      <OEText fontFamily={secondaryFontFamily} fontType="bold" fontSize={20}>
        {lessonName}
      </OEText>
    </View>
  );
};
